module.exports = __webpack_public_path__ + "img/home.62a81295.jpg";